/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var CopyIcon20Solid = forwardRef('CopyIcon20Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 20 }, props),
        React.createElement("path", { d: "M6 1a3 3 0 0 0-3 3v10a3 3 0 0 0 3 3h6a3 3 0 0 0 3-3V4a3 3 0 0 0-3-3H6Z" }),
        React.createElement("path", { d: "M17.563 7.5a.75.75 0 1 0-1.5 0v6.781a3.75 3.75 0 0 1-3.75 3.75H7.5a.75.75 0 0 0 0 1.5h4.813c2.899 0 5.25-2.35 5.25-5.25V7.5Z" })));
});
